import { Link } from "react-router-dom";
import { formatDate } from "../formatters";
import type { ParcoursResponse } from "../../api/parcoursApi";

export default function ParcoursCard({ parcours }: { parcours: ParcoursResponse }) {
  // Earliest start; latest of (endDate ?? date) across all slots.
  const starts = (parcours.dates ?? []).map((d) => d.date).filter(Boolean).sort();
  const ends = (parcours.dates ?? [])
    .map((d) => d.endDate || d.date)
    .filter(Boolean)
    .sort() as string[];
  const firstDate = starts[0];
  const lastDate = ends[ends.length - 1];
  const range = firstDate && lastDate && firstDate !== lastDate
    ? `${formatDate(firstDate)} → ${formatDate(lastDate)}`
    : formatDate(firstDate);

  return (
    <Link to={`/parcours/${parcours.id}`} className="fo-card">
      <div className="fo-card__media">
        {parcours.imageLink ? (
          <img src={parcours.imageLink} alt={parcours.title} loading="lazy" />
        ) : (
          <div className="fo-card__placeholder">Parcours</div>
        )}
        {parcours.paid ? (
          <span className="fo-card__badge fo-card__badge--paid">Payant</span>
        ) : (
          <span className="fo-card__badge">Gratuit</span>
        )}
      </div>
      <div className="fo-card__body">
        <h3 className="fo-card__title">{parcours.title}</h3>
        <div className="fo-card__meta">
          {parcours.mainCommune && <span>📍 {parcours.mainCommune}</span>}
          {firstDate && <span>📅 {range}</span>}
        </div>
        {parcours.description && <p className="fo-card__desc">{parcours.description}</p>}
      </div>
    </Link>
  );
}
